




































































































import Vue, { PropType } from 'vue';
import {
  Entry,
  PublicBuyer,
  PublicBuyerCompany,
  PublicExhibition,
  PublicOffline,
  PublicOfflineDay,

  PublicExhibitor,
  PublicExhibitorCompany,
  calender,

} from 'mostra';

import {
  genDownloadImageUrlByImage,
  sizes,
  Image,
} from '@/modules/image';

// import { FirestoreDate } from '@/modules/firestore';
// import { formatContactListDate } from '@/modules/calender';
// import { calender } from 'mostra';

export default Vue.extend({
  name: 'GChatBrandListItem',
  props: {
    entry: {
      type: Object as PropType<Entry>,
      required: true,
    },
    buyer: {
      type: Object as PropType<PublicBuyer>,
      required: true,
    },
    buyerCompany: {
      type: Object as PropType<PublicBuyerCompany>,
      required: true,
    },
    exhibition: {
      type: Object as PropType<PublicExhibition>,
      required: true,
    },
    offline: {
      type: Object as PropType<PublicOffline>,
      required: true,
    },
    offlineDay: {
      type: Object as PropType<PublicOfflineDay>,
      required: true,
    },
    exhibitor: {
      type: Object as PropType<PublicExhibitor>,
      required: true,
    },
    exhibitorCompany: {
      type: Object as PropType<PublicExhibitorCompany>,
      required: true,
    },
  },
  // props: {
  //   name: { type: String as PropType<string>, default: '' },
  //   brand: { type: String as PropType<string>, default: '' },
  //   brandLogoSrc: { type: String as PropType<string>, default: null },
  //   brandImageSrc: { type: String as PropType<string>, default: null },
  //   avatar: {
  //     type: String as PropType<string>,
  //     default: null,
  //   },
  //   company: {
  //     type: String as PropType<string>,
  //     default: '',
  //   },
  //   date: {
  //     type: [Date, Object] as PropType<FirestoreDate>,
  //   },
  //   latestMessageText: {
  //     type: String as PropType<string>,
  //     default: '',
  //   },
  //   latestMessageWithUrl: {
  //     type: Boolean as PropType<boolean>,
  //     default: false,
  //   },
  //   latestMessageWithAttachment: {
  //     type: Boolean as PropType<boolean>,
  //     default: false,
  //   },
  //   unseen: {
  //     type: Boolean as PropType<boolean>,
  //     default: false,
  //   },
  //   unreplied: {
  //     type: Boolean as PropType<boolean>,
  //     default: false,
  //   },
  // },
  // data() {
  //   return {
  //     displayDate: calender.formatContactListDate(this.date),
  //   };
  // },
  asyncComputed: {
    async logo() {
      const url = (this as any).genImageUrl(this.exhibition.data.images.logo, sizes.x512);
      return url;
    },
    async image() {
      const url = (this as any).genImageUrl(this.exhibition.data.visitor.images[0], sizes.x512);
      return url;
    },
  },
  computed: {
    yearString() {
      return calender.formatYear(this.offlineDay.date);
    },
    dateString() {
      return calender.formatOnlyDateDot(this.offlineDay.date);
    },
    dayString() {
      return calender.formatDayEN(this.offlineDay.date);
    },
    openingFromDateString() {
      return calender.formatDateDot(this.offline.openingDate.fromDate);
    },
    openingToDateString() {
      return calender.formatDateDot(this.offline.openingDate.toDate);
    },
    openingToDayString() {
      return calender.formatDayEN(this.offline.openingDate.toDate);
    },
    openingDateString() {
      return `${calender.formatDateDot(this.offline.openingDate.fromDate)}(${calender.formatDayEN(this.offline.openingDate.fromDate)})-${calender.formatOnlyDateDot(this.offline.openingDate.toDate)}(${calender.formatDayEN(this.offline.openingDate.toDate)})`;
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
    async genImageUrl(image: Image, size: string): Promise<string | null> {
      const url = await genDownloadImageUrlByImage(
        size,
        image,
      );
      return url;
    },

  },
});
